import type { IssueDetailFeatureToggleInitProps } from "../src/issue_detail_v2/feature_toggle/types/init";

window.EasyIssueDetailV2 ||= {};

window.EasyIssueDetailV2.initFeatureToggle = async (
  elementId: string,
  props: IssueDetailFeatureToggleInitProps
): Promise<void> => {
  const { initFeatureToggle } = await import("../src/issue_detail_v2/feature_toggle/main");
  await initFeatureToggle(elementId, props);
};
